import axios from 'axios';
import {
    brandsRequest,
    brandsSuccess,
    brandsFail,
    adminBrandsFail,
    adminBrandsRequest,
    adminBrandsSuccess,
    clearError as clearBrandsError,
} from '../slices/BrandsSlice';

import {
    brandRequest,
    brandSuccess,
    brandFail,
    clearError as clearBrandError,
    clearBrand,
    newBrandFail,
    newBrandSuccess,
    newBrandRequest,
    clearBrandCreated,
    deleteBrandFail,
    deleteBrandRequest,
    deleteBrandSuccess,
    clearBrandDeleted,
    updateBrandFail,
    updateBrandRequest,
    updateBrandSuccess,
    clearBrandUpdated,
} from '../slices/brandSlice';

export const getAdminBrand = (id) => async (dispatch) => {

    try {
        dispatch(brandRequest())
        const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/admin/brand/${id}`);

        dispatch(brandSuccess(data))
    } catch (error) {
        const message =
            error?.response?.data?.message || error.message || "Something went wrong";
        dispatch(brandFail(message))
    }

}

export const createNewBrand = formData => async (dispatch) => {
    try {
        dispatch( newBrandRequest )
        const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/api/v1/admin/brand/new`, formData);
        dispatch(newBrandSuccess(data))
            
    } catch (error) {
        const message =
            error?.response?.data?.message || error.message || "Something went wrong";
        dispatch(newBrandFail(message))
    }
}

export const updateBrand = (id, productData) => async (dispatch) => {

    try {
        dispatch(updateBrandRequest())
        const { data } = await axios.put(`${process.env.REACT_APP_API_URL}/api/v1/admin/brand/${id}`, productData);
        dispatch(updateBrandSuccess(data))
    } catch (error) {
        //handle error
        const message =
            error?.response?.data?.message || error.message || "Something went wrong";
        dispatch(updateBrandFail(message))
    }

}

export const toggleBrandActive = (id) => async (dispatch) => {

    try {
        dispatch(updateBrandRequest())
        const { data } = await axios.put(`${process.env.REACT_APP_API_URL}/api/v1/admin/brand/status/${id}`);
        dispatch(updateBrandSuccess(data))
    } catch (error) {
        //handle error
        const message =
            error?.response?.data?.message || error.message || "Something went wrong";
        dispatch(updateBrandFail(message))
    }

}

export const deleteBrand = (id) => async (dispatch) => {

    try {
        dispatch(deleteBrandRequest())
        const { data } = await axios.delete(`${process.env.REACT_APP_API_URL}/api/v1/admin/brand/${id}`);
        dispatch(deleteBrandSuccess(data))
    } catch (error) {
        //handle error
        const message =
            error?.response?.data?.message || error.message || "Something went wrong";
        dispatch(deleteBrandFail(message))
    }
}

export const getAdminBrands = () => async (dispatch) => {

    try {
        dispatch(adminBrandsRequest())
        const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/admin/brands`);
        dispatch(adminBrandsSuccess(data))
    } catch (error) {
        const message =
            error?.response?.data?.message || error.message || "Something went wrong";
        dispatch(adminBrandsFail(message));
    }

}

export const getAdminActiveBrands = () => async (dispatch) => {

    try {
        dispatch(adminBrandsRequest())
        const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/admin/active/brands`);
        dispatch(adminBrandsSuccess(data))
    } catch (error) {
        const message =
            error?.response?.data?.message || error.message || "Something went wrong";
        dispatch(adminBrandsFail(message));
    }

}

export const getActiveBrands = () => async (dispatch) => {

    try {
        dispatch(adminBrandsRequest())
        const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/active/brands`);
        dispatch(adminBrandsSuccess(data))
    } catch (error) {
        const message =
            error?.response?.data?.message || error.message || "Something went wrong";
        dispatch(adminBrandsFail(message));
    }

}